/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AbpPtwExceptionHttpResponseModelData } from './AbpPtwExceptionHttpResponseModelData';
import {
    AbpPtwExceptionHttpResponseModelDataFromJSON,
    AbpPtwExceptionHttpResponseModelDataFromJSONTyped,
    AbpPtwExceptionHttpResponseModelDataToJSON,
} from './AbpPtwExceptionHttpResponseModelData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100ForbiddenException
 */
export interface Ptw100ForbiddenException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100ForbiddenException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100ForbiddenException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {AbpPtwExceptionHttpResponseModelData}
     * @memberof Ptw100ForbiddenException
     */
    data?: AbpPtwExceptionHttpResponseModelData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100ForbiddenException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100ForbiddenException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100ForbiddenException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100ForbiddenException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100ForbiddenException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100ForbiddenException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100ForbiddenException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {string}
     * @memberof Ptw100ForbiddenException
     */
    $type?: Ptw100ForbiddenExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100ForbiddenExceptionTypeEnum = {
    PtwPtw100AppZeroCoreSharedExceptionsPtw100ForbiddenExceptionPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100ForbiddenException, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type Ptw100ForbiddenExceptionTypeEnum = typeof Ptw100ForbiddenExceptionTypeEnum[keyof typeof Ptw100ForbiddenExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100ForbiddenException interface.
 */
export function instanceOfPtw100ForbiddenException(value?: unknown): value is Ptw100ForbiddenException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100ForbiddenExceptionTypeEnum)[0];
}

export function Ptw100ForbiddenExceptionFromJSON(json: any): Ptw100ForbiddenException {
    return Ptw100ForbiddenExceptionFromJSONTyped(json, false);
}

export function Ptw100ForbiddenExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100ForbiddenException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AbpPtwExceptionHttpResponseModelDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100ForbiddenExceptionToJSON(value?: Omit<Ptw100ForbiddenException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': AbpPtwExceptionHttpResponseModelDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        '$type': value['$type'],
    });
}

